export enum Bit2meBrokerTierEnum {
  pro = 'BPR',
  lite = 'BLT',
}
